import React, { forwardRef } from 'react';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
  icon?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ error, icon, className = '', ...props }, ref) => {
    const classes = [
      'input',
      error ? 'input-error' : '',
      className,
    ]
      .filter(Boolean)
      .join(' ');

    return (
      <div className="input-wrapper" style={{ position: 'relative' }}>
        <input
          ref={ref}
          className={classes}
          aria-invalid={!!error}
          {...props}
        />
        {icon && (
          <span
            style={{
              position: 'absolute',
              right: 'var(--space-4)',
              top: '50%',
              transform: 'translateY(-50%)',
            }}
          >
            {icon}
          </span>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;
